export default {
  header: 'Nouvelles commandes suspendues',
  text: "Appuyez n'importe où pour reprendre",
};
